import React from 'react';
import { Button } from '@headlessui/react';
import { FaHome, FaArrowLeft } from 'react-icons/fa';

const LandingPageError = ({ 
  title = "Something went wrong", 
  message = "An error occurred while loading the page.", 
  onBack, 
  showBackButton = true 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-2xl lg:text-3xl font-bold text-white mb-2">{title}</h1>
          <p className="text-gray-400 text-base lg:text-lg">{message}</p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showBackButton && onBack && (
            <Button
              onClick={onBack}
              className="flex items-center justify-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors border border-gray-700"
            >
              <FaArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
          )}
          <Button
            onClick={() => window.location.href = '/dashboard'}
            className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            <FaHome className="mr-2 h-4 w-4" />
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LandingPageError;
